export const CitiesHubContent = {
  bannerTitle: "Miasta, w których działamy",
  mapAside: {
    eyebrow: "Obsługa ogólnopolska",
    title: "Usługi dostępne w całej Polsce, z wyborem miasta na start",
    paragraphs: [
      "inspektomat.pl pomaga znaleźć wykonawców przeglądów bezpieczeństwa w różnych częściach Polski. Niezależnie od tego, czy szukasz przeglądu dla mieszkania, domu, lokalu usługowego czy całego budynku, możesz zacząć od wyboru miasta na mapie.",
      "Na stronach miejskich zbieramy usługi związane z kontrolami elektrycznymi, gazowymi, kominowymi, wentylacyjnymi, przeciwpożarowymi i budowlanymi. Dzięki temu łatwiej sprawdzić lokalną dostępność firm, porównać zakres prac i przejść do zamówienia przeglądu bez szukania wykonawców osobno w każdym regionie.",
    ],
    bullets: [
      "Przeglądy instalacji elektrycznej, odgromowej i pomiary elektryczne",
      "Kontrole gazowe, próby szczelności i serwis kotłów",
      "Usługi kominiarskie, wentylacyjne, ppoż. oraz przeglądy budowlane",
    ],
    closing:
      "Kliknij wybrane miasto, aby przejść do lokalnej strony usług i sprawdzić dostępne przeglądy dla swojej nieruchomości.",
  },
  cityGrid: {
    title: "Wszystkie miasta",
    subtitle: "Pełna lista miast, w których działamy",
  },
  serviceStripTitle: "Znajdź przegląd w swoim mieście",
  knowledgeStripTitle: "Dowiedz się więcej o bezpieczeństwie",
  seo: {
    title: "Miasta, w których działamy",
    description:
      "Pełna lista stron miejskich inspektomat.pl. Wybierz miasto i sprawdź dostępne przeglądy instalacji oraz lokalne oferty firm.",
  },
};
